import { PartnerDropdownContextStateType, PartnerDropdownContextValueType, PartnerDropdownProviderProps } from "@src/lib/types/partner-provider";
import Config from "@src/utils/api/config";
import { useInputHelper } from "@src/utils/inputs-helper";
import { createContext, useContext, useMemo } from "react";

const initialState: PartnerDropdownContextStateType = {
	selectedPartnerId: Config.PARTNER_ID,
}

const PartnerDropdownContext = createContext<PartnerDropdownContextValueType>({} as PartnerDropdownContextValueType);

export const PartnerDropdownProvider = ({ children }: PartnerDropdownProviderProps) => {
	const { state, onDispatch, handleFormReset } = useInputHelper(initialState);

	const handleSelectPartner = (value: PartnerDropdownContextStateType) => {
		onDispatch('selectedPartnerId')(value);
	};

	const partner = useMemo(() => {
		switch(state.selectedPartnerId){
			case 1: case "1": default:
				return 'fortune8';
			case 2: case "2":
				return 'gamezone';
			case 3: case "3":
				return 'palmsplay';
			case 4: case "4":
				return 'palmssport';
			case 5: case "5":
				return 'gambly';
		}
	},[state?.selectedPartnerId]);

	const value = {
		state,
		partner,
		onDispatch,
		handleSelectPartner,
		handleFormReset,
	};

	return (
		<PartnerDropdownContext.Provider value={value}>
			{children}
		</PartnerDropdownContext.Provider>
	)
}

export const usePartnerDropdownContext = () => {
	return useContext(PartnerDropdownContext);
};